


















































import { Component, Vue } from "vue-property-decorator";
import LocaleChanger from "@/components/LocaleChanger.vue";
@Component({ components: { LocaleChanger } })
export default class HomeFooter extends Vue {
    public icons: Array<{ icon?: string; link: string; src?: string }> = [
        { src: "mdi-twitter", link: "https://twitter.com/zieglercloud" },
        {
            icon: "mdi-xing",
            link: "https://www.xing.com/profile/Andreas_Ziegler125/cv",
        },
        { icon: "mdi-github", link: "https://github.com/LindezaGrey" },
        { icon: "mdi-mail", link: "mailto:andy@zieglercloud.de" },
    ];
    public items: Array<{ text: string; disabled: boolean; to: string }> = [
        {
            text: "DSGVO",
            disabled: false,
            to: "/legal#dsgvo",
        },
        {
            text: "Impressum",
            disabled: false,
            to: "/legal#impressum",
        },
        {
            text: "AGB",
            disabled: false,
            to: "/legal#AGB",
        },
        {
            text: "Support",
            disabled: false,
            to: "/support",
        },
    ];
}
